import CircularProgress from '@material-ui/core/CircularProgress';
import { progressStyle } from './style';

export default function CircularProgressBar(props) {
  const styleConf = {
    color: props.color || "#fff"
  }
  const classes = progressStyle(styleConf);

  return (
    <CircularProgress classes={{ root: classes.root }} size={props.size || 18} />
  );
}